<template>
    <section id="home" class="section welcome-area bg-overlay d-flex align-items-center">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <!-- Welcome Intro Start -->
                    <div class="col-12 col-lg-7">
                        <div class="welcome-intro">
                            <h1 class="text-white">"Netflix* as a service"</h1>
                            <p class="text-white my-4">Turnkey OTT gives you the ability to create your own Netflix-like platform, complete with subscriptions, recommendation system, conent delivery platform, analytics and more. Just bring your content, we'll do the rest.</p>
                            <p class="text-white my-4">*SourceSync is not affilated with, and does not incorporate Netflix.</p>
                            <!-- Store Buttons -->
                            <div class="button-group store-buttons d-flex">
                                <a href="#" class="btn sApp-btn text-uppercase">Start free trial</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-8 col-lg-5">
                        <!-- Contact Box -->
                        <div class="contact-box bg-white text-center rounded p-4 p-sm-5 mt-5 mt-lg-0 shadow-lg">
                            <!-- Contact Form -->
                            <form id="contact-form" method="POST" action="assets/php/top-mail.php">
                                <div class="contact-top">
                                    <h3 class="contact-title">Get started for FREE!</h3>
                                    <h5 class="text-secondary fw-3 py-3">We will setup a free trial of our Turnkey OTT product for you at no charge. Phone is optional. If you provide it we'll call it. We will never send you spam.</h5>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <input type="text" class="form-control" name="name" placeholder="Name" required="required">
                                        </div>
                                        <div class="form-group">
                                            <input type="email" class="form-control" name="email" placeholder="Email" required="required">
                                        </div>
                                        <div class="form-group">
                                            <input type="text" class="form-control" name="phone" placeholder="Phone" required="required">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <button class="btn btn-bordered w-100 mt-3 mt-sm-4" type="submit">Contact Me</button>
                                        <div class="contact-bottom">
                                            <span class="d-inline-block mt-3">If you fill in this form, we will contact you about our Turnkey OTT product offering. Please see our <a href="#">Terms</a> &amp; <a href="#">Privacy Policy</a> for any questions or concerns.</span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <p class="form-message"></p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Shape Bottom -->
            <div class="shape-bottom">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none">
                    <path class="shape-fill" fill="#FFFFFF" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7  c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4  c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path>
                </svg>
            </div>
        </section>
</template>

<script>
export default {
    
}
</script>

<style>

</style>